import React from 'react';
import styled from 'styled-components';
import { ReactComponent as WhatappIcon } from '../../assets/whatsapp.svg';
import { ReactComponent as TelegramIcon } from '../../assets/telegram.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/youtube.svg';
import { ReactComponent as FacebookSvgIcon } from "../../assets/facebook.svg";
import { ReactComponent as EmailIcon } from '../../assets/email.svg';
import { Link } from '../atoms/Link';
import { PageRoutes } from '../../constants/routes';
import { useLanguage } from '../../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <FooterWrapper>
      <NavLinks>
        <NavLink as={Link} to={PageRoutes.HOME}>{t('header.home')}</NavLink>
        <NavLink as={Link} to={PageRoutes.PROPERTY.RESIDENTIAL}>{t('header.properties')}</NavLink>
        <NavLink as={Link} to={PageRoutes.BLOG}>{t('header.blog')}</NavLink>
        <NavLink as={Link} to={PageRoutes.ABOUT}>{t('header.about')}</NavLink>
        <NavLink as={Link} to={PageRoutes.CONTACT}>{t('header.contact')}</NavLink>
      </NavLinks>
      <SocialRow>
      <SocialIcon href="https://www.youtube.com/@LIVINGPP" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YoutubeIcon /></SocialIcon>
      <SocialIcon href="https://www.facebook.com/livingpp" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FacebookSvgIcon /></SocialIcon>
        <SocialIcon href="https://t.me/+85585281712" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><TelegramIcon /></SocialIcon>
        <SocialIcon href="https://wa.me/85585281712" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><WhatappIcon /></SocialIcon>
        <SocialIcon href="mailto:Livingppbox@gmail.com" target="_blank" rel="noopener noreferrer" aria-label="Email"><EmailIcon /></SocialIcon>
      </SocialRow>
      {/* <Copyright>© {year} LIVINGPP. All rights reserved.</Copyright> */}
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer`
  background: #18145a;
  color: #fff;
  padding: 24px 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 100;
  
  @media (min-width: 400px) {
    padding: 28px 16px 20px;
  }
  
  @media (min-width: 768px) {
    padding: 32px 24px 24px;
  }
  
  @media (min-width: 1024px) {
    padding: 36px 0 24px;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  gap: 8px;
  
  @media (min-width: 400px) {
    margin: 0 0 18px 0;
    gap: 12px;
  }
  
  @media (min-width: 768px) {
    gap: 16px;
  }
  
  @media (max-width: 600px) {
    max-width: 280px;
    margin: 0 auto 16px auto;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    
    > li {
      width: calc(50% - 4px);
      text-align: center;
      margin-bottom: 8px;
    }
  }
`;

const NavLink = styled.li`
  margin: 0;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  margin-bottom: 0;
  
  @media (min-width: 768px) {
    font-size: 15px;
  }
  
  &:hover {
    text-decoration: underline;
  }
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
  
  @media (min-width: 400px) {
    margin-bottom: 14px;
    gap: 20px;
  }
  
  @media (min-width: 768px) {
    margin-bottom: 16px;
    gap: 24px;
  }
`;

const SocialIcon = styled.a`
  color: #fff;
  font-size: 20px;
  margin: 0;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (min-width: 768px) {
    font-size: 22px;
  }
  
  svg {
    width: 22px;
    height: 22px;
    fill: #fff;
    transition: fill 0.2s;
    
    @media (min-width: 768px) {
      width: 25px;
      height: 24px;
    }
  }
  
  &:hover svg {
    fill: #ffe14d;
  }
`;

export default Footer;
